import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Paper,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Autocomplete,
    Modal,
    Button,
  } from "@mui/material";
  import moment from "moment";
  import React, { useEffect, useState } from "react";
  import { getRequest, server } from "../../config";
  import dayjs from "dayjs";
  const PastRequestHistory = ({ partnerId }) => {
    const [specificDate, setSpecificDate] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalEarning, settotalEarning] = useState(0);
    const [range, setrange] = useState("");
    const [actualData, setactualData] = useState([]);
    const [contractData, setcontractData] = useState([])
    const [slot, setslot] = useState([
      "Same Range",
      "100-10000",
      "10000-1 lakh",
      "Above 1 lakh",
    ]);
    const computeEarning = (response) => {
      let sum = 0;
      const arraycontract = [];
      response?.map((item) => {
        const price = parseInt(item?.amount);
        let tempprice = 0;
        if (price <= 10000 && price >= 0) {
          tempprice = price - 100;
        } else if (price > 10000 && price < 100000) {
          tempprice = (price * 95) / 100;
        } else if (price >= 100000) {
          tempprice = price - 5000;
        }
        arraycontract.push(tempprice);
        sum += tempprice;
      });
      setactualData([...actualData]);
      settotalEarning(sum);
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    // Handle rows per page change
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0); // Reset to the first page when rows per page changes
    };
    useEffect(() => {
      fetchCustomers();
    }, [page, rowsPerPage, specificDate]);
    const fetchCustomers = async () => {
      try {
        const filter = {
          skip: page * rowsPerPage,
          limit: rowsPerPage,
        };
  
        const response = await getRequest(
          `${server.uri}requestlogs?filter={"where":{"or":
        [{"acceptedPartners":{"inq":["${partnerId}"]}},
        {"notAcceptedPartners":{"inq":["${partnerId}"]}}]
        },
            "skip":"${filter.skip}",
              "limit":"${filter.limit}"
      
              ,"order":"requestedAt desc","include":[{"relation":"user"}]}`
        );
        //   console.log(response);
        setCustomers(response);
        
        const responseCount = await getRequest(
          `${server.uri}requestlogs/count?where={
              "or":
        [{"acceptedPartners":{"inq":["${partnerId}"]}},
        {"notAcceptedPartners":{"inq":["${partnerId}"]}}]
              }`
        );
  
        console.log(responseCount);
  
        setTotalCount(responseCount.count);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    const handleChangeStatus=(e)=>{
      const value=e.target.value
      const filter = contractData?.filter(item => item?.range == value);
      setrange(value)
      computeEarning(filter)
      setCustomers(filter)
      
      
    }
    return (
      <Container>
       
        <Typography sx={{ textAlign: "right" }} variant="subtitle1" gutterBottom>
          Total Contracts: <strong>{totalCount}</strong>
        </Typography>
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f4f6f8", // Light background for table header
                  }}
                >
                  <TableCell sx={{ fontWeight: "bold" }}>Customer Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Mobile Number</TableCell>
  
                
                  <TableCell sx={{ fontWeight: "bold" }}>Address</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Requested At</TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
                {customers?.map((customer) => (
                  <TableRow
                    sx={{
                      "&:nth-of-type(even)": {
                        backgroundColor: "#f9fafb", // Alternate row color for better readability
                      },
                    }}
                    key={customer.requestLogId}
                  >
                    <TableCell sx={{ cursor: "pointer" }}>
                      {customer?.user?.name}
                    </TableCell>
                    <TableCell>
                      {customer?.user?.mobileNumber}
                    </TableCell>
  
            
                    <TableCell>{customer?.user?.fullAddress}</TableCell>
                    <TableCell>{customer?.user?.city}</TableCell>
  
                    <TableCell>{((customer?.acceptedPartners?.find((item)=>item)))?<p className="bg-green-200 text-center py-1 text-green-950 font-mono rounded-sm">Accepted</p>:<p className="bg-red-200 text-center py-1 text-red-950 font-mono rounded-sm">Rejected</p>}</TableCell>
                    <TableCell>
                     {moment(customer?.requestedAt).format('DD-MM-YYYY HH:mm ')}
                    </TableCell>
                   
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
  
          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25,50,100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <Typography
            sx={{ textAlign: "right", marginRight: 2 }}
            variant="subtitle1"
            gutterBottom
          >
            Total Earning: <strong>₹ {totalEarning?.toFixed(2)}</strong>
          </Typography>
        </Paper>
      </Container>
    );
  };
  
  export default PastRequestHistory;
  